import { useEffect, useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase/firebase';
import { useAdminAuth } from '../../context/AdminAuthContext';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { currentUser, isAdmin, loading: authLoading, logout } = useAdminAuth();

  // Go to the dashboard only once the context has confirmed this user is an admin
  useEffect(() => {
    if (!authLoading && currentUser && isAdmin) {
      navigate('/admin', { replace: true });
    }
  }, [authLoading, currentUser, isAdmin, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      console.error('Login error:', err);
      const code = err.code || '';
      setError(
        ['auth/invalid-credential', 'auth/wrong-password', 'auth/user-not-found'].includes(code)
          ? 'Incorrect email or password.'
          : `Sign-in failed (${code || 'unknown error'}).`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 360, margin: '80px auto', padding: 24 }}>
      <h1>Admin Login</h1>

      {currentUser && authLoading && <p>Verifying admin access...</p>}

      {currentUser && !authLoading && !isAdmin && (
        <div style={{ color: 'red', marginBottom: 16 }}>
          <p>You're signed in, but this account isn't set up as an admin.</p>
          <p>
            UID: <code>{currentUser.uid}</code>. The document ID in the{' '}
            <code>admins</code> collection must match it exactly.
          </p>
          <button type="button" onClick={logout}>Sign out</button>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label>Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={{ width: '100%', padding: 8, marginTop: 4 }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required style={{ width: '100%', padding: 8, marginTop: 4 }} />
        </div>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <button type="submit" disabled={loading} style={{ width: '100%', padding: 10 }}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;